import styled, { css } from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { motion } from 'framer-motion'
import { chevronMoveDirectionOptions } from './constants'

const GroupList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow: hidden;
  width: 100%;
`

const ItemContainer = styled.div`
  padding: 0 1rem;
  min-width: 150px;
  min-height: 48px;
  width: 100%;
  gap: 0.5rem;
  z-index: 2;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  position: relative;

  &:hover {
    background: ${colorsOptions.greys['grey-05']};
  }

  &:active {
    background: ${colorsOptions.greys['grey-10']};
  }

  ${({ borderBottom, borderFull, isOpen }) =>
    !isOpen &&
    borderBottom &&
    (borderFull
      ? `border-bottom: 1px solid ${colorsOptions.greys['grey-20']};`
      : `&::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 1rem;
          right: 0rem;
          height: 1px;
          background-color: ${colorsOptions.greys['grey-20']};
        }`)}

  background: ${({ backgroundActive }) =>
    backgroundActive ? colorsOptions.greys['grey-10'] : 'transparent'};

  ${({ isSelected }) =>
    isSelected &&
    `
    background: ${colorsOptions.greys['grey-05']};
  `}
`

const ItemCollumn = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
`

const ItemChevron = styled(ItemCollumn)`
  width: auto;
  height: auto;

  transition: transform 0.3s ease;
  transform: ${({ isOpen, chevronMoveDirection }) =>
    chevronMoveDirection === chevronMoveDirectionOptions.RIGHT_TO_DOWN
      ? isOpen
        ? css`rotate(90deg)`
        : css`rotate(0deg)`
      : isOpen
        ? css`rotate(-90deg)`
        : css`rotate(90deg)`};
`

const ItemIcon = styled(ItemCollumn)`
  width: 32px;
  height: 32px;
`

const ItemTextContent = styled(ItemCollumn)`
  min-width: 20%;
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ItemTitle = styled.span`
  padding: 0.25rem 0 0.125rem;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};

  color: ${({ color }) => color ?? colorsOptions.greys['grey-100']};

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isSelected }) =>
    isSelected
      ? textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]
      : textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
`

const ItemDescription = styled.span`
  padding: 0 0 0.25rem;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-70']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]};
`

const ItemBadge = styled(ItemCollumn)``

const ItemValue = styled(ItemCollumn)`
  min-width: 45px;
  max-width: 150px;
  width: fit-content;
  display: inline-block;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  color: ${({ color }) => color ?? colorsOptions.greys['grey-100']};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ItemCount = styled(ItemCollumn)``

const CollapsibleContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  position: relative;

  ${({ borderBottom, borderFull }) =>
    borderBottom &&
    (borderFull
      ? `border-bottom: 1px solid ${colorsOptions.greys['grey-20']};`
      : `&::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 1rem;
          right: 0rem;
          height: 1px;
          background-color: ${colorsOptions.greys['grey-20']};
        }`)}
`

export {
  GroupList,
  ItemContainer,
  ItemChevron,
  ItemIcon,
  ItemTextContent,
  ItemTitle,
  ItemDescription,
  ItemBadge,
  ItemValue,
  ItemCount,
  CollapsibleContainer
}
